module.exports = __webpack_public_path__ + "img/side-arch-high.167b0bfb.svg";